/* eslint-disable react-hooks/exhaustive-deps */
import { Link } from "react-router-dom";
import DoneIcon from "@mui/icons-material/Done";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Faqs from "../../../Faqs";
import AIEnhanced from "../../../../assets/final-images/servicepage/mri-page/Artboard 4.jpg";
import DTI from "../../../../assets/final-images/servicepage/mri-page/Artboard 5.jpg";
import SpineMRI from "../../../../assets/final-images/servicepage/mri-page/Artboard 6.jpg";
import Fatman from "../../../../assets/final-images/servicepage/mri-page/image.png";
import kneeMRI from "../../../../assets/final-images/servicepage/mri-page/Artboard 7.jpg";
import PIPCases from "../../../../assets/final-images/servicepage/mri-page/Artboard 8.jpg";
import shapeImage from "../../../../assets/final-images/shapes/abstruct.png";
import BrainVideo from "../../../../assets/final-images/servicepage/mri-page/MRI brain iac video.mp4";

export default function MRIAI() {
  const faqs = [
  {
    question: "What is a brain MRI and what can it detect?",
    answer:
      "A brain MRI uses powerful magnetic fields and radio waves to produce highly detailed images of the brain and surrounding structures - without any radiation. It can detect and evaluate stroke, brain tumors, multiple sclerosis, white matter disease, hydrocephalus, cerebral aneurysms, intracranial hemorrhage, dementia, epilepsy, infections, and traumatic brain injury. At Citrus Diagnostic Center, brain MRI is interpreted by our board-certified radiologist with results delivered promptly to your referring physician."
  },
  {
    question: "When does a doctor order a brain MRI?",
    answer:
      "Physicians commonly order brain MRI to evaluate new or worsening headaches, dizziness or vertigo, vision changes, memory loss or cognitive decline, seizures, weakness or numbness, speech difficulties, sudden loss of coordination, suspected stroke or TIA, or to monitor a known brain condition or tumor. Neurologists, primary care physicians, neurosurgeons, and emergency physicians are among the most common referring providers."
  },
  {
    question: "How long does a brain MRI take at Citrus Diagnostic Center?",
    answer:
      "A standard brain MRI without contrast typically takes 20 to 45 minutes. If your physician has ordered a brain MRI with contrast (gadolinium), the exam will take approximately 30 to 45 minutes, as additional sequences are performed after the contrast injection. You will be asked to lie still inside the MRI scanner during the exam."
  },
  {
    question: "Does a brain MRI require contrast dye?",
    answer:
      "Not always. Many brain MRI studies are performed without contrast. However, your physician may order a brain MRI with contrast (gadolinium injected through an IV) to better evaluate tumors, infections, inflammation, or vascular abnormalities. Some brain MRI protocols include both non-contrast and contrast sequences in the same appointment. If contrast is ordered, our staff will review your kidney function history and any prior contrast reactions before administering it."
  },
  {
    question: "Is a brain MRI safe? Are there any risks?",
    answer:
      "Brain MRI is very safe. It uses no ionizing radiation, making it appropriate for repeated examinations and patients of all ages. The primary safety considerations involve the strong magnetic field: patients with certain metallic implants, pacemakers, cochlear implants, or metal fragments may not be eligible for MRI or may require special precautions. You will complete a thorough safety screening questionnaire before your exam."
  }
];
  return (
    <div>
      <div
        style={{
          background:
            "linear-gradient(to right, #3d0e26 0%, #8b5e3c 50%,  #330a16 100%)",
        }}
      >
        <div className="md:max-w-[90%] w-11/12 mx-auto pt-20 lg:mb-28">
          <div className="pb-10">
            <h2 className="lg:text-[52px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  capitalize  text-center pb-5">
              Support for Anxious or Claustrophobic Patients
            </h2>
            <div className="text-center">
              <p className="font-robout  space-y-6 py-2">
                Most patients are able to complete MRI comfortably using our
                open-bore design and patient-centered approach.
              </p>
              <p className="font-robout space-y-6">
                <span className="font-extrabold">
                  Need extra help relaxing?
                </span>{" "}
                In some cases, medication may be prescribed to help anxious or
                claustrophobic patients complete their MRI comfortably.
              </p>
            </div>
          </div>
          <div className="bg-black rounded-xl xl:p-10 py-10">
            <div className="grid grid-col-1 xl:grid-cols-2 lg:gap-20 gap-10 lg:pt-20   ">
              <div className="xl:bg-[#000] rounded-xl xl:p-8 px-5 ">
                <div className="pb-8">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  capitalize">
                    AI-Enhanced MRI
                  </h2>
                  <p className="text-[#cccccc] font-normal  ">
                    Smarter imaging. Better outcomes.
                  </p>
                </div>
                <p className="pb-2">
                  Artificial intelligence is integrated into our MRI workflow
                  to:
                </p>
                <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2">
                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Improve image sharpness</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Reduce scan times</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Minimize motion artifacts</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>
                      Maintain diagnostic quality at lower signal thresholds
                    </span>
                  </li>
                </ul>
                <p className=" py-2">The result:</p>
                <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2">
                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Faster exams</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Fewer repeat scans</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>More reliable interpretations</span>
                  </li>
                </ul>
              </div>
              <div className="">
                <img
                  src={AIEnhanced}
                  alt="Ai Enhanced MRI"
                  className="w-auto h-auto rounded-3xl"
                />
              </div>
            </div>
            <div className="grid grid-col-1 xl:grid-cols-2 lg:gap-20 gap-10 lg:py-20 pt-10">
              <div className="order-2 xl:order-1 ">
                <video
                  src={BrainVideo}
                  autoPlay
                  loop
                  muted
                  playsInline title="Advanced Neuroimaging & Brain MRI"
                  className="w-auto h-auto rounded-3xl object-center"
                >
                  Your browser does not support the video tag.
                </video>
              </div>
              <div className="p-8 bg-[#000] rounded-xl order-1 xl:order-2 ">
                <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  text-left capitalize">
                  Advanced Neuroimaging & Brain MRI
                </h2>
                <h3 className="lg:text-[22px] text-[18px] leading-[1.4em] text-[#cccccc] font-normal pt-8">
                  Brain MRI
                </h3>
                <p className="py-2">Used to evaluate:</p>
                <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2 ">
                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Headache</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Stroke and TIA</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Seizures</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Memory loss</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Neurodegenerative disease</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Trauma and concussion</span>
                  </li>
                </ul>
                <p className=" py-2">Protocols are tailored for:</p>
                <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2">
                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Structural detail</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Vascular assessment</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Microstructural analysis</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="grid grid-col-1 xl:grid-cols-2 lg:gap-20 gap-10 lg:py-0 py-10">
              <div className="p-8 bg-[#000] rounded-xl">
                <div className="pb-8">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  text-left capitalize">
                    Brain DTI (Diffusion Tensor Imaging)
                  </h2>
                  <p className=" text-[#cccccc] font-normal">
                    When conventional imaging isn’t enough.
                  </p>
                </div>
                <p className="pb-2">
                  DTI MRI evaluates the brain’s white matter pathways and is
                  especially valuable in:
                </p>
                <ul className="lg:text-[24px] text-[18px] leading-[1.4em] text-[#cccccc] space-y-2  ">
                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Traumatic brain injury (TBI)</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Concussion and post-concussive symptoms</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>
                      Cognitive and neurologic complaints following trauma
                    </span>
                  </li>
                </ul>
                <p className="py-2">This advanced technique requires:</p>
                <ul className="lg:text-[24px] text-[18px] leading-[1.4em] text-[#cccccc] space-y-2">
                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Precise acquisition</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Experienced interpretation</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Clinical correlation</span>
                  </li>
                </ul>
                <p className="py-2">
                  At Citrus Diagnostic Center, DTI is performed and interpreted
                  by radiologists with{" "}
                  <span className="font-extrabold">
                    academic and trauma-center experience
                  </span>
                  .
                </p>
              </div>
              <div className="">
                <img
                  src={DTI}
                  alt="Diffusion Tensor Imaging"
                  className="w-auto h-auto rounded-3xl"
                />
              </div>
            </div>
          </div>
          <div className="xl:pt-24 pt-10">
            <h2 className="lg:text-[52px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  capitalize  text-center">
              Spine MRI & Whiplash Protocols
            </h2>
            <div className="grid grid-col-1 xl:grid-cols-2 xl:gap-20 gap-10 xl:py-20 py-10">
              <div className="">
                <img
                  src={SpineMRI}
                  alt="Spine MRI Imaging"
                  className="w-auto h-auto rounded-3xl"
                />
              </div>
              <div className=" 2xl:px-12 xl:px-8 px-2">
                <h3 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#cccccc] font-normal pb-8">
                  Comprehensive Spine Imaging
                </h3>
                <p className="pb-2">
                  MRI of the cervical, thoracic, and lumbar spine is used to
                  assess:
                </p>
                <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2">
                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Disc disease</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Nerve compression</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Spinal cord abnormalities</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Ligamentous injury</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Degenerative and traumatic conditions</span>
                  </li>
                </ul>
                <div>
                  <h3 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#cccccc] font-normal pb-8 pt-14">
                    Whiplash & Cervical Trauma Imaging
                  </h3>
                  <p className="pb-2">
                    For personal injury and motor vehicle accidents, we offer:
                  </p>
                  <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2">
                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>
                        Dedicated{" "}
                        <span className="font-extrabold">
                          whiplash MRI protocols
                        </span>
                      </span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>
                        Focused evaluation of the{" "}
                        <span className="font-extrabold">alar ligaments</span>
                      </span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>
                        High-resolution assessment of soft tissues often missed
                        on routine imaging
                      </span>
                    </li>
                  </ul>
                  <p className="py-2">Designed for:</p>
                  <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2">
                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Accurate diagnosis</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Objective documentation</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Clinical and legal clarity</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="md:max-w-[90%] w-11/12 mx-auto py-10 xl:py-0  lg:mb-12">
        <div>
          <h2 className=" lg:text-[52px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  capitalize  text-center">
            Body MRI
          </h2>
          <div className="grid grid-col-1 xl:grid-cols-3 xl:gap-10 3xl:gap-24  xl:py-20 justify-center items-center">
            <div className="p-8 xl:bg-[#0f0f0f] rounded-xl h-auto xl:h-[45rem] 3xl:h-[35rem]">
              <h3 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#cccccc] font-normal pb-8 ">
                Comprehensive insight. No radiation.
              </h3>
              <p className="pb-2">
                Citrus Diagnostic Center offers{" "}
                <span className="font-extrabold">
                  comprehensive Body MRI protocols{" "}
                </span>
                similar to those used at leading university hospitals and
                advanced private imaging centers.
              </p>
              <p className="py-2">Unlike CT, MRI provides:</p>
              <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2">
                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Superior soft tissue contrast</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Functional tissue characterization</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span className="font-extrabold">No radiation exposure</span>
                </li>
              </ul>
            </div>
            <div className="p-8 xl:bg-[#0f0f0f] rounded-xl h-auto xl:h-[45rem] 3xl:h-[35rem]">
              <h3 className="lg:text-[38px] text-[24px] leading-[1.2em] pb-8 text-[#cccccc] font-normal ">
                Advanced capability. Thoughtful application. Physician
                oversight.
              </h3>
              <p className="pb-2">Body MRI may be utilized for:</p>
              <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2">
                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span className="font-extrabold">
                    Cancer detection, staging, and surveillance
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>
                    Liver imaging (including focal lesions and diffuse disease)
                  </span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Pancreatic and biliary evaluation</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Renal and adrenal imaging</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Pelvic imaging (prostate, gynecologic conditions)</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Evaluation of inflammatory or systemic disease</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>
                    Selected preventive or risk-based imaging strategies
                  </span>
                </li>
              </ul>
              <p className="py-2">
                Each exam is{" "}
                <span className="font-extrabold">purpose-driven</span> and
                tailored-not one-size-fits-all.
              </p>
            </div>
            <div className="p-8 xl:bg-[#0f0f0f] rounded-xl h-auto xl:h-[45rem] 3xl:h-[35rem]">
              <div className="pb-8">
                <h3 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#cccccc] font-normal  ">
                  Body MRI vs. “One-Size-Fits-All” Scans
                </h3>
                <p className=" text-[#cccccc] font-normal">
                  Not all Body MRI exams are the same.
                </p>
              </div>
              <p className="py-2">At Citrus Diagnostic Center:</p>
              <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2 ">
                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>
                    Exams are{" "}
                    <span className="font-extrabold">
                      clinically indicated and customized
                    </span>
                  </span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Radiologists remain actively involved</span>
                </li>

                <li className="flex items-start gap-2">
                  <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>
                    Imaging findings are interpreted in full medical context
                  </span>
                </li>
              </ul>
              <p className="py-2">
                This approach emphasizes{" "}
                <span className="font-extrabold">
                  accuracy, relevance, and safety
                </span>{" "}
                over generic screening.
              </p>
            </div>
          </div>
        </div>
        <div className="py-10">
          <img src={Fatman} alt=" Body MRI vs. “One-Size-Fits-All” Scans" className="rounded-xl" />
        </div>
        <div
          className="grid grid-col-1 xl:grid-cols-2 xl:gap-20 gap-10  xl:py-20 mb-10 py-10 px-5 xl:px-10 rounded-xl"
          style={{
            background:
              "linear-gradient(to right, #3d0e26 0%, #8b5e3c 50%,  #330a16 100%)",
          }}
        >
          <div className="flex flex-col justify-center items-start">
            <div className="pb-8">
              <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  text-center xl:text-left capitalize">
                Musculoskeletal MRI
              </h2>
              <p className=" text-[#cccccc] font-normal  ">
                Movement matters. Precision matters more.
              </p>
            </div>
            <p className="pb-2">MRI is the gold standard for evaluating:</p>
            <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2">
              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                <span>Sports injuries</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                <span>Joint pain</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                <span>Tendon and ligament tears</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                <span>Cartilage and marrow abnormalities</span>
              </li>
            </ul>
            <p className="py-2">
              Our fellowship-trained background in musculoskeletal imaging
              ensures:
            </p>
            <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2 ">
              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                <span>Clear diagnoses</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                <span>Actionable reports</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                <span>Meaningful correlation with symptoms</span>
              </li>
            </ul>
          </div>
          <div>
            <img
              src={kneeMRI}
              alt="Knee MRI imaging"
              className="w-auto h-auto rounded-3xl"
            />
          </div>
          <div className="order-2 xl:order-1">
            <img
              src={PIPCases}
              alt="MRI for Personal Injury & PIP Case"
              className="w-auto h-auto rounded-3xl"
            />
          </div>
          <div className="order-1 xl:order-2 flex flex-col justify-center items-start">
            <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] pb-8 text-[#f5f5f5] font-normal font-heading  text-center xl:text-left capitalize">
              MRI for Personal Injury & PIP Cases
            </h2>
            <p className="pb-2">
              Citrus Diagnostic Center is a regional leader in{" "}
              <span className="font-extrabold">
                MRI for Auto / PIP / Personal Injury imaging
              </span>
              , including:
            </p>
            <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2 ">
              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                <span>Brain MRI &amp; DTI</span>
              </li>

              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                <span>Cervical, thoracic, and lumbar spine MRI</span>
              </li>

              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                <span>Dedicated trauma protocols</span>
              </li>
            </ul>
            <p className="py-2">Our approach emphasizes:</p>
            <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2 ">
              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                <span>Protocol consistency</span>
              </li>

              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                <span>High-quality documentation</span>
              </li>

              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                <span>Defensible, clinically grounded interpretations</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="relative">
        <img
          src={shapeImage}
          alt="shape"
          className="
      absolute 
      top-1/2 
      left-1/2 
      -translate-x-1/2 
      -translate-y-1/2 
      pointer-events-none 
      z-0
      opacity-55
    "
        />
        <div className="w-[95%] xl:w-[80%] mx-auto pb-8 xl:pt-16">
          <div
            className="backdrop-blur-[2px]
    bg-[#ffffff13] rounded-xl  border border-[#ffffff49]
      shadow-lg  p-5 md:p-10"
          >
            <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] xl:pb-8 pt-5 xl:pt-0 text-[#f5f5f5] font-normal font-heading  text-left capitalize">
              Patient Comfort & Safety
            </h2>
            <div className="grid grid-col-1 xl:grid-cols-2 xl:gap-20">
              <div className=" xl:p-8 p-5 ">
                <h3 className="lg:text-[22px] text-[18px] leading-[1.4em] text-[#cccccc] font-normal  py-5 xl:py-0 ">
                  Designed Around You
                </h3>
                <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2 mt-4">
                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Wide-bore systems for comfort</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Shorter scan times</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Clear communication from technologists</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Calm, patient-centered environment</span>
                  </li>
                </ul>
              </div>
              <div className="xl:p-8 p-5 ">
                <h2 className="lg:text-[22px] text-[18px] leading-[1.4em] text-[#cccccc] font-normal  py-5 xl:py-0 ">
                  Safety First
                </h2>
                <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2 mt-4">
                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Strict MRI safety screening</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Radiologist oversight</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Adherence to national safety standards</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            className="backdrop-blur-[2px]
    bg-[#ffffff13] rounded-xl  border border-[#ffffff49]
      shadow-lg  p-5 md:p-10  md:py-16 my-10"
          >
            <div className="grid grid-col-1 xl:grid-cols-2 xl:gap-20 gap-10">
              <div className=" 2xl:px-12 xl:px-8 px-2 ">
                <div className=" pb-8 pt-8 xl:pt-0">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  text-left capitalize">
                    For Patients
                  </h2>
                  <p className=" text-[#cccccc] font-normal ">
                    Knowledge empowers choice.
                  </p>
                </div>
                <div>
                  <p className="pb-2 lg:w-[80%]">
                    MRI is safe, non-invasive, and does not use ionizing
                    radiation. Our team works closely with trusted national
                    educational resources to help patients understand:
                  </p>
                  <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2">
                    <li className="flex items-start gap-2">
                      <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>Why an MRI is ordered</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>What it evaluates</span>
                    </li>

                    <li className="flex items-start gap-2">
                      <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                      <span>
                        What to expect before, during, and after the exam
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className=" xl:py-0 py-4">
                <div className="pb-8">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading  text-left capitalize">
                    For Referring Providers
                  </h2>
                  <p className=" text-[#cccccc] font-normal  ">
                    Built for Clinical Confidence
                  </p>
                </div>
                <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2">
                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>ACR-aligned protocols</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Subspecialty interpretation</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Clear, timely reports</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Direct radiologist communication when needed</span>
                  </li>
                </ul>
                <p className="py-2">
                  We see MRI as a{" "}
                  <span className="font-extrabold">clinical partnership</span>,
                  not a commodity.
                </p>
              </div>
            </div>
          </div>
          <div
            className="backdrop-blur-[2px]
    bg-[#ffffff13] rounded-xl  border border-[#ffffff49]
      shadow-lg  p-5 md:p-10"
          >
            <div className="grid grid-col-1 xl:grid-cols-2 xl:gap-20 gap-5">
              <div className=" xl:p-8 p-5">
                <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] text-[#f5f5f5] font-normal font-heading text-left capitalize pb-8">
                  The Citrus Diagnostic Center Difference
                </h2>
                <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2 ">
                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Radiologist owned and operated</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Board-certified, fellowship-trained expertise</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Research-grade MRI technology</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>AI-enhanced imaging</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                    <span>Patient-first philosophy</span>
                  </li>
                </ul>
              </div>
              <div className=" xl:p-8 p-5 ">
                <h2 className="lg:text-[38px] text-[24px] leading-[1.2em] pb-8 text-[#f5f5f5] font-normal font-heading  text-left capitalize">
                  Patient Choice in MRI
                </h2>
                <p className="pb-2 ">
                  Patients have the right to ask where their MRI is performed
                  and who interprets their study.
                </p>
                <p className="pb-2">
                  MRI interpretation is a medical specialty, and experience in
                  protocol design and subspecialty interpretation can
                  matter-especially for neurologic, spine, musculoskeletal, and
                  prostate imaging.
                </p>
                <p className=" pb-2 ">
                  We encourage patients to discuss imaging options with their
                  care team and choose the setting that best supports accurate
                  diagnosis.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="lg:w-[80%] w-[90%] mx-auto  lg:pb-10">

        <Faqs faqs={faqs}/>
      </div>
      <div className="md:max-w-[90%] w-11/12 mx-auto">
        <div className="flex justify-center items-center  py-12">
          <div
            style={{
              background: `
                              linear-gradient(90deg,
                            #3d0e26 0%,
                            #5a1f33 1%,
                            #8b5e3c 40%,
                            #8b5e3c 70%,
                            #5a1f33 95%,
                            #330a16 100%
                          )
                            `,
            }}
            className="flex justify-center items-center flex-col py-8 px-6 xl:px-8 rounded-xl xl:w-[668px] "
          >
            <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading texc  capitalize  ">
              Schedule with Confidence
            </h2>
            <p className=" pt-5  text-center">
              Advanced MRI-guided by physicians who put accuracy, safety, and
              patient care first.
            </p>
            <div className="pt-10 pb-2">
              <Link
                data-aos="fade-up"
                to="/contact-us"
                aria-label="Schedule Now"
                className="px-8 py-2.5 rounded-3xl bg-white text-black font-bold text-[17px] hover:bg-black hover:border hover:text-white border border-[#ffffff5d] transition-all duration-300"
              >
                Schedule Now
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
